export const billOverviewConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        getSpecificInvoiceDetails_request: "getSpecificInvoiceDetails_request",
        getSpecificInvoiceDetails_success: "getSpecificInvoiceDetails_success",
        getSpecificInvoiceDetails_failure: "getSpecificInvoiceDetails_failure",
    }

    let obj_formatted = {};
    let domain = "billingPortal.billOverview/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}